import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import logoLight from "../assets/images/logo-light-new.png";

const Footer = () => {
  const year = new Date().getFullYear().toString();

  return (
    <>
      <section className="footer bg-dark">
        <Container>
          <Row>
            <Col lg={3} className="text-center text-lg-start">
              <div className="footer-logo mb-4">
                <Link to="#">
                  <img src={logoLight} alt="" />
                </Link>
              </div>
              <Link to="#" className="text-white">
                hello@codeforgeit.com
              </Link>

              {/* <h5 className="fs-18 mb-3 text-white">Follow Us</h5> */}
              {/* <ul className="list-inline mt-5">
                <li className="list-inline-item">
                  <Link to="#;" className="footer-social-icon">
                    <i className="mdi mdi-facebook"></i>
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link to="#;" className="footer-social-icon">
                    <i className="mdi mdi-twitter"></i>
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link to="#;" className="footer-social-icon">
                    <i className="mdi mdi-linkedin"></i>
                  </Link>
                </li>                
              </ul> */}
            </Col>
            <Col lg={9}>
              <Row>
                <Col sm={6} md={3}>
                  <h5 className="fs-22 mb-3 fw-semibold text-white">
                    Our Information
                  </h5>
                  <ul className="list-unstyled footer-nav">
                    <li>
                      <Link
                        reloadDocument
                        to="/privacy-policy"
                        className="footer-link"
                      >
                        Privacy Policy
                      </Link>
                    </li>
                    <li>
                      <Link
                        reloadDocument
                        to="/terms-and-conditions"
                        className="footer-link"
                      >
                        Terms & Conditions
                      </Link>
                    </li>
                    <li>
                      <Link
                        reloadDocument
                        to="/data-disclaimer"
                        className="footer-link"
                      >
                        Data Disclaimer
                      </Link>
                    </li>
                  </ul>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
      <div className="footer-tagline">
        <Container>
          <Row className="justify-content-between py-2">
            <Col md={6}>
              <p className="text-white opacity-75 mb-0 fs-14">
                {year} © Equitix - Product of{" "}
                <Link
                  style={{ color: "#8FA64C" }}
                  to="https://codeforgeit.com/"
                  className="text-white"
                >
                  CodeForge
                </Link>{" "}
                for Software Solutions
              </p>
            </Col>
            <Col md={6} className="text-md-end"></Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Footer;
